import { motion } from 'motion/react';
import { FC } from 'react';
// @ts-expect-error - react-qr-code types are incorrect, runtime uses named export https://github.com/rosskhanas/react-qr-code/issues/251
import { QRCode } from 'react-qr-code';

import Heading1 from '@/components/text/Heading1.tsx';
import Paragraph from '@/components/text/Paragraph.tsx';

import useConfig from '@/hooks/useConfig.ts';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { buildPatientAppUrl } from '@/utils/customer-utils.ts';

export interface Props {
    code: string;
    instanceId: string;
}

const FormQRCode: FC<Props> = ({ code, instanceId }) => {
    const { selected_location, getInstanceConfig } = useConfig();
    const is_form_code_linking_enabled = getInstanceConfig(instanceId)?.is_form_code_linking_enabled;
    let qr_code_url = buildPatientAppUrl(ServiceUrl.PATIENT_APP.ALL_FORMS_CODE);
    if (is_form_code_linking_enabled) {
        qr_code_url = buildPatientAppUrl(
            `${ServiceUrl.PATIENT_APP.FORMS}/${code}?location_key=${selected_location.key}`
        );
    }

    return (
        <div className="flex flex-col items-center gap-8 px-12 py-28">
            <QRCode value={qr_code_url} />
            <Paragraph>
                Bitte scannen Sie den QR-Code und geben Sie die unten angezeigte Nummer ein.
                {/* Please scan the QR Code and input the number shown below. */}
            </Paragraph>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.2, delay: 0.3 }}>
                <Heading1>{code}</Heading1>
            </motion.div>
        </div>
    );
};

export default FormQRCode;
